export default "__VITE_ASSET__BloLlVrC__"